module.exports = __webpack_public_path__ + "static/img/psytest_logo.df0a125.png";